exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h5[data-v-61af11c2]{padding:0;margin:15px 0 0 0;text-align:center}", ""]);

